// src/features/auth/register/register.utils.js

export const onlyPhoneChars = (value = "") =>
  String(value).replace(/[^\d+]/g, "").trim();

export const normalizePhone = (value = "") => {
  let phone = onlyPhoneChars(value);

  if (!phone) return "";

  if (phone.startsWith("+")) {
    phone = phone.slice(1);
  }

  if (phone.startsWith("0")) {
    return `62${phone.slice(1)}`;
  }

  if (phone.startsWith("8")) {
    return `62${phone}`;
  }

  if (phone.startsWith("62")) {
    return phone;
  }

  return phone;
};

export const isValidEmail = (value = "") => {
  if (!value) return true;
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

export const getInitialFormState = () => ({
  name: "",
  email: "",
  phone: "",
  password: "",
  confirmPassword: "",
  agreeTerms: false,
  termsRead: false,
  privacyRead: false,
});

export const validateRegisterForm = (form, documentsReady = true) => {
  const errors = {};

  if (!form.name.trim()) {
    errors.name = "Nama lengkap wajib diisi.";
  }

  if (!form.phone.trim()) {
    errors.phone = "Nomor WhatsApp wajib diisi.";
  }

  if (form.email.trim() && !isValidEmail(form.email.trim())) {
    errors.email = "Format email tidak valid.";
  }

  if (!form.password) {
    errors.password = "Kata sandi wajib diisi.";
  } else if (form.password.length < 8) {
    errors.password = "Minimal 8 karakter.";
  }

  if (!form.confirmPassword) {
    errors.confirmPassword = "Konfirmasi kata sandi wajib diisi.";
  } else if (form.password !== form.confirmPassword) {
    errors.confirmPassword = "Konfirmasi kata sandi tidak cocok.";
  }

  if (!documentsReady) {
    errors.general = "Dokumen legal belum berhasil dimuat.";
  }

  if (!form.termsRead) {
    errors.termsRead = "Buka dan baca Syarat dan Ketentuan terlebih dahulu.";
  }

  if (!form.privacyRead) {
    errors.privacyRead = "Buka dan baca Kebijakan Privasi terlebih dahulu.";
  }

  if (!form.agreeTerms) {
    errors.agreeTerms = "Anda harus menyetujui syarat & ketentuan dan kebijakan privasi.";
  }

  return errors;
};

export const mapBackendErrors = (responseData) => {
  const backendErrors = responseData?.errors || {};

  return {
    name: backendErrors.name?.[0] || "",
    email: backendErrors.email?.[0] || "",
    phone: backendErrors.phone_number?.[0] || "",
    password: backendErrors.password?.[0] || "",
    confirmPassword: backendErrors.password_confirmation?.[0] || "",
    agreeTerms: backendErrors.agreeTerms?.[0] || "",
    termsRead: backendErrors.termsRead?.[0] || "",
    privacyRead: backendErrors.privacyRead?.[0] || "",
    general: responseData?.message || "Validasi gagal.",
  };
};

export const formatLegalTypeLabel = (type = "") => {
  switch (type) {
    case "terms_and_conditions":
      return "Syarat dan Ketentuan";
    case "privacy_policy":
      return "Kebijakan Privasi";
    default:
      return "Dokumen Legal";
  }
};
